
import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

export interface AddGroupCardProps {
  onAddGroup: () => void;
}

const AddGroupCard: React.FC<AddGroupCardProps> = ({ onAddGroup }) => {
  return (
    <Card className="shadow-sm border-dashed border-2 h-full flex flex-col justify-center items-center p-6">
      <CardContent className="flex flex-col items-center justify-center text-center pt-6">
        <div className="rounded-full bg-primary/10 p-3 mb-4">
          <Plus className="h-6 w-6 text-primary" />
        </div>
        <h3 className="font-medium mb-2">Create a new group</h3>
        <p className="text-sm text-muted-foreground mb-4">
          Group products together for easier tracking
        </p>
        <Button onClick={onAddGroup}>Add Group</Button>
      </CardContent>
    </Card>
  );
};

export default AddGroupCard;
